import { LitElement } from 'lit';
import { unsafeStatic, html } from "lit/static-html.js";
import { i18n } from '@lingui/core';
import { messages as nbMessages} from '../src/raw/success/locales/nb/messages.mjs';
import { messages as enMessages} from '../src/raw/success/locales/en/messages.mjs';
import { messages as fiMessages} from '../src/raw/success/locales/fi/messages.mjs';
import { messages as daMessages} from '../src/raw/success/locales/da/messages.mjs';
import { messages as svMessages} from '../src/raw/success/locales/sv/messages.mjs';
import { activateI18n } from '../src/utils/i18n';
activateI18n(enMessages, nbMessages, fiMessages, daMessages, svMessages);


export class IconSuccess16 extends LitElement {
  render() {
      const title = i18n.t({ message: `Circle with checkmark`, id: 'icon.title.success', comment: 'Title for success icon' });
      
      return html`<svg xmlns="http://www.w3.org/2000/svg"width="16"height="16"fill="none"viewBox="0 0 16 16" part="w-icon-success-16-part">${unsafeStatic(`<title>${title}</title>`)}<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="m4 8.815 1.633 2.318a.7.7 0 0 0 1.138.034l5.228-6.615"></path><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M.5 7.999a7.5 7.5 0 1 0 15 0 7.5 7.5 0 0 0-15 0"></path></svg>`; }
}
if (!customElements.get('w-icon-success-16')) {
  customElements.define('w-icon-success-16', IconSuccess16);
}